(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_card"] && !Shopify.designMode) return;
  try {
    class ReadMoreCard extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const body = this.querySelector('.text-block.rte');
      if (!body) return;

      const moreLabel = this.dataset.moreLabel || 'Read more';
      const lessLabel = this.dataset.lessLabel || 'Read less';

      /*
        Wrap ONLY the body text.

        We do not wrap the complete <read-more-card>, because
        display: contents is being used so images/headings can
        continue behaving as direct flex children.
      */
      const wrapper = document.createElement('div');
      wrapper.className = 'read-more-card__text-wrap';

      body.parentNode.insertBefore(wrapper, body);
      wrapper.appendChild(body);

      /*
        Create Read more button.
      */
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'read-more-card__toggle';
      button.hidden = true;

      const dots = document.createElement('span');
      dots.className = 'read-more-card__dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.textContent = '...';

      const label = document.createElement('span');
      label.className = 'read-more-card__label';
      label.textContent = moreLabel;

      button.appendChild(dots);
      button.appendChild(label);

      button.setAttribute('aria-expanded', 'false');

      if (!body.id) {
        body.id = `read-more-card-body-${Math.random()
          .toString(36)
          .slice(2, 9)}`;
      }

      button.setAttribute('aria-controls', body.id);

      wrapper.appendChild(button);

      /*
        Check whether the text actually overflows the selected
        number of lines.
      */
      const updateVisibility = () => {
        const expanded =
          this.getAttribute('data-expanded') === 'true';

        if (expanded) return;

        /*
          Temporarily hide the button so it doesn't interfere
          with measuring the text.
        */
        button.hidden = true;

        requestAnimationFrame(() => {
          const hasOverflow =
            body.scrollHeight > body.clientHeight + 1;

          button.hidden = !hasOverflow;
        });
      };

      /*
        Expand / collapse
      */
      button.addEventListener('click', () => {
        const expanded =
          this.getAttribute('data-expanded') === 'true';

        if (expanded) {
          /* COLLAPSE */
          this.setAttribute('data-expanded', 'false');

          button.setAttribute('aria-expanded', 'false');

          dots.style.display = '';
          label.textContent = moreLabel;

          requestAnimationFrame(updateVisibility);
        } else {
          /* EXPAND */
          this.setAttribute('data-expanded', 'true');

          button.setAttribute('aria-expanded', 'true');

          dots.style.display = 'none';
          label.textContent = lessLabel;

          button.hidden = false;
        }
      });

      /*
        Initial calculation after browser layout.
      */
      requestAnimationFrame(() => {
        updateVisibility();
      });

      /*
        Re-check if card width changes.
      */
      if (window.ResizeObserver) {
        const observer = new ResizeObserver(() => {
          if (this.getAttribute('data-expanded') !== 'true') {
            updateVisibility();
          }
        });

        observer.observe(wrapper);
      } else {
        window.addEventListener('resize', updateVisibility);
      }
    }
  }

  if (!customElements.get('read-more-card')) {
    customElements.define('read-more-card', ReadMoreCard);
  }
  } catch(e) { console.error(e); }
})();

})();
